import { render } from "./VideoForm.vue?vue&type=template&id=e44a7358&scoped=true"
import script from "./VideoForm.vue?vue&type=script&lang=js"
export * from "./VideoForm.vue?vue&type=script&lang=js"

import "./VideoForm.vue?vue&type=style&index=0&id=e44a7358&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3966428095/src/eelam-tv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e44a7358"]])

export default __exports__